import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Form,
  Table,
  Container,
  Button,
  Card,
} from "react-bootstrap";
import { connect } from "react-redux";
import { isEmpty, get, find, isUndefined, filter } from "lodash";
import { getEmployeeData, addSTAccount, getEmployeeDataWithStatus, addSTReciving } from "./HRDetails.actions";
import Spinner from "react-bootstrap/Spinner";
import Select from "react-select";
import MaterialTable from "material-table";
import Swal from 'sweetalert';
import { appendNonSignificantZeros } from "../../../../../global/globalFunctions";

const STReciving= (props) => {

  const [accountNo, setaccountNo] = useState();
  const [selectedAccount, setSelectedAccount] = useState('');
  const [cashAccountTitle, setCashAccountTitle] = useState();
  const [cashAccountTitleKey, setCashAccountTitleKey] = useState();
  const [employeeName, setEmployeeName] = useState();
  const [employeeId, setEmployeeId] = useState('');
  const [descriptionLT, setLTDescription] = useState();
  const [amount, setAmount] = useState('');
  const [deduction, setDeduction] = useState('');
  const [accType, setAccType] = useState("");
  const [date, setDate] = useState('');
  const [stadv, setStAdv] = useState();
  const [voucher, setVoucher] = useState();
  const [datestate, setDatestate] = useState("");
  const [visibleAlert, setAlertVisible] = useState(false);
  const [dangerVisibleAlert, setDangerVisibleAlert] = useState(false);

  const handleVisible = () => {
    setAlertVisible(true);
    clearStates();
    setTimeout(() => {
      setAlertVisible(false)
    }, 9000);
    Swal({
      title: "Success",
      text: "Added successfully...",
      icon: "success",
      button: "Ok",
    });
  }

  const handleDangerVisible = () => {
    setDangerVisibleAlert(true)
    setTimeout(() => {
      setDangerVisibleAlert(false)
    }, 9000);
    Swal({
      title: "Error",
      text: "Please Update The Master Controller First...",
      icon: "error",
      button: "Ok",
    });
  }
  console.log(datestate, "sssssssssssssssss");
  // const [values, setValues] = useState({
  //   voucherDescription: "",
  //   voucherAmount: "",
  //   PONo: "",
  //   billNo: "",
  //   accountTittle: "",
  //   // payTo: "",
  //   levelFiveId: "",
  //   voucherDate: "",
  //   accountType: "2",
  //   account: "",
  // });

  // const getEmployeeList = !isEmpty(props.employeeList) ? props.employeeList.map((x) => { let data = { value: x.employeeId, label: `${x.employeeId} ${x.name}` }; return data }) : [];

  const getEmployeeList = !isEmpty(props.employeeList) && props.employeeList.map((x) => { let data = { value: x.employeeId, label: `${appendNonSignificantZeros(x.employeeId)}-${x.name}` }; return data })

  // const inputEvent = (event) => {
  //   setValues({
  //     ...values,
  //     [event.target.name]: event.target.value,
  //   });
  //   setDatestate(event.target.value);
  // };


  // const cashAccountNo =
  //   !isEmpty(props.level5List) &&
  //   props.level5List.map((x) => {
  //     let data = {
  //       value: x.levelfiveData.levelFiveId,
  //       label:
  //         x.levelfiveData.allLevelKey + " /" + x.levelfiveData.levelFiveName,
  //     };
  //     return data;
  //   });

  // const cashAccountNoTop =
  //   !isEmpty(props.level5List) &&
  //   props.level5List
  //     .filter((x) => x.levelfiveData.levelFourId == level4Id)
  //     .map((y) => {
  //       let data = {
  //         value: y.levelfiveData.levelFiveId,
  //         label:
  //           y.levelfiveData.allLevelKey + " /" + y.levelfiveData.levelFiveName,
  //       };
  //       return data;
  //     });

  // const handleChangeAccountNo = (selectedOption) => {
  //   setaccountNo(selectedOption.value);
  //   setCashAccountTitle(
  //     find(
  //       props.ltAccount,
  //       (x) => x.levelFiveId == selectedOption.label,
  //     ).levelFiveName,
  //     console.log(cashAccountTitle,'accccc')
  //   );

  //   setCashAccountTitleKey(
  //     find(
  //       props.ltAccount,
  //       (x) => x.levelFiveId == selectedOption.value
  //     ).levelFiveId
  //   );
  //   // setSelectedAccount(selectedOption)
  // };
  const clearStates = () => {
    setEmployeeId('');
    setAmount('');
    setDeduction('');
    setDate('');
  }

  const getLevelFourList =
    !isEmpty(props.level4List) &&
    props.level4List.map((x) => {
      let data = {
        value: x.levelFourData.levelFourId,
        label: x.levelFourData.allLevlKey + "/ " + x.levelFourData.levelFourName,
      };
      return data;
    });


  const cash = props.ltAccount;
  console.log(cash, "cashhhhhhhhhhhhhhhhhhh");

  const [state, setState] = React.useState({
    columns: [
      { title: "Date", field: "data.voucherDate" },
      { title: "Account Name", field: "data.accountTittle" },
      { title: "Bill No", field: "data.billNo" },
      { title: "Description", field: "data.voucherDescription" },
      { title: "Amount", field: "data.voucherAmount" },
      // {
      //   title: "DR/CR",
      //   field: "data.accountType",
      //   render: (rowData) =>
      //     rowData.data.accountType == 1
      //       ? "Credit"
      //       : rowData.data.accountType == 2
      //         ? "Debit"
      //         : "---",
      // },
    ],
  });

  // const addPayment = () => {
  //   let newVal = values;
  //   if (!isEmpty(datestate)) newVal.voucherDate = datestate;
  //   props.submitCashPayment(newVal);
  //   setValues({
  //     voucherDescription: "",
  //     voucherAmount: "",
  //     PONo: "",
  //     billNo: "",
  //     accountTittle: "",
  //     // payTo: "",
  //     levelFiveId: "",
  //     voucherDate: "",
  //     accountType: "2",
  //     account: "",
  //   });
  //   setCashAccountTitle("");
  //   setLevel4Lablel("")
  // };
  const handleChangeEmployee = (selectedOption) => {
    setEmployeeId(selectedOption.value);
    setEmployeeName(selectedOption.label);
    console.log(selectedOption.value, selectedOption.label, 'dddd')
    setStAdv(find(props.employeeList, x => x.employeeId == selectedOption.value).st_adv)
  };
  useEffect(() => {
    //props.getLTAccount();
    props.getEmployeeData();
  }, []);
  const SaveSTAccount = () => {
    props.addSTReciving({
      employee_id: employeeId,
      short_term_data_acc_type: accType,
      short_term_data_description: descriptionLT,
      short_term_data_amount: amount,
      //short_term_data_deduction_value: deduction,
      short_term_data_date: date,
    }, handleVisible, handleDangerVisible);
    //props.resetFunction();
    console.log(stadv,"adv")
  };
  return (
    <>
      {props.isFetchingEmployeeData ? (
        <div className="loader-div">
          <Button variant="info" disabled>
            <Spinner
              animation="grow"
              size="sm"
              role="status"
              aria-hidden="true"
              variant="info"
            />
          </Button>
        </div>
      ) : (
        <Container fluid>
          <div className="main">
            <Card style={{ padding: "3%" }}>
              {/* <Row>
                <Col lg="12">
                  <div className="text-white">
                    <Row>
                      <Col lg="6" sm="12">
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label>Cash A/C No</Form.Label>
                          <Select
                            value={{ label: cashAccountTitle }}
                            className="selectOptionColor"
                            isDisabled
                            placeholder="Select Cash Account No..."
                            onChange={handleChangeAccountNo}
                            options={filter(cashAccountNoTop, x => x.value !== values.levelFiveId)}
                          />
                        </Form.Group>
                      </Col>

                      <Col lg="6" sm="12">
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                          <Form.Label>Account Type</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter Amount Type"
                            value="Debit"
                            readOnly
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row> */}
              <div style={{ padding: "1% 0" }}>
                <Row>
                  <Col lg="4" sm="12">
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>Select Employee</Form.Label>
                      <Select
                        //value={name}
                        placeholder="Select Employee..."
                        onChange={handleChangeEmployee}
                        options={getEmployeeList}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg="4" sm="12">
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>Date</Form.Label>
                      <Form.Control
                        type="date"
                        onChange={(e) => setDate(e.target.value)}
                      ></Form.Control>
                    </Form.Group>
                  </Col>
                  <Col lg="4" sm="12">
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>Method</Form.Label>
                      <Select
                        // isDisabled={isEmpty(getDepartmentNameList)}
                        placeholder="Select Method..."
                        onChange={(selectedOption) => { setAccType(selectedOption.label)}}
                        options={[{value: "1", label: "Cash"}, {value: "2", label: "Bank"}]}
                        // value={{
                        //   value: (STAccounts.cashId === "" && !isEmpty(props.selectedMasterData)) ? props.selectedMasterData[0].levelFiveId : STAccounts.cashId, /*Sometimes the indexing is opposite, then both values get swapped*/
                        //   label: (STAccounts.cashId === "" && !isEmpty(props.selectedMasterData)) ? props.selectedMasterData[0].levelFiveName : STAccounts.cashname
                        // }}
                      />
                      </Form.Group>
                  </Col>
                </Row>
              </div>
              <div style={{ padding: "1% 0" }}>
                <Row>
                  <Col lg="4" sm="12">
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>Description</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter description"
                        id="descriptionID"
                        name="voucherDescription"
                        //value={values.voucherDescription}
                        onBlur={(e) => setLTDescription((e.target.value).toUpperCase())}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg="4" sm="12">
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>Amount</Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="Enter Amount"
                        id="amountID"
                        name="voucherAmount"
                        //value={values.voucherAmount}
                        //maxValue={props.employeeList.lt_adv}
                        
                       disabled={true}
                       value={stadv}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg="4" sm="12">
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>Amount</Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="Enter Amount"
                        id="amountID"
                        name="voucherAmount"
                        //value={values.voucherAmount}
                        value={amount}
                        max={stadv}
                        onChange={
                            (e) =>Number(e.target.value) <= stadv && setAmount(e.target.value)
                        }

                      />
                      {/* // max={ltadv}
                        onChange={
                          (e) =>  Number(e.target.value) <= ltadv && setAmount(e.target.value)
                        } */}
                    </Form.Group>
                  </Col>
                  {/* <Col lg="4" sm="12">
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>Deduction Value</Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="Enter Deduction..."
                        // min="2"
                        // max="99"
                        // isInvalid={deduction < 2 || deduction > 99}
                        defaultValue={deduction}
                        id="billno"
                        name="billNo"
                        //value={values.billNo}
                        onBlur={(e) => setDeduction(e.target.value)}
                        disabled={true}
                      />
                    </Form.Group>
                  </Col> */}
                </Row>
              </div>

              <Row>
                <Col lg="12" sm="12" className="text-center">
                {console.log((employeeId === '') || (amount === '') || (deduction === '') || (date === ''), "STAdvance")}
                  {((employeeId === '') || (amount === '')  || (date === ''))   ? <Button style={{backgroundColor:'black'}} className="sendButtonVoucher" disabled size="large" onClick={SaveSTAccount}>Save</Button> : <Button className="sendButtonVoucher" onClick={SaveSTAccount}>Save</Button>}
                </Col>
              </Row>
            </Card>
          </div>
        </Container>
      )}
    </>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    //getLTAccount: () => dispatch(getLTAccount()),
    getEmployeeData: () => dispatch(getEmployeeData()),
    addSTReciving: (data, handleVisible, handleDangerVisible) => dispatch(addSTReciving(data, handleVisible, handleDangerVisible)),
    // addCashPayment: (data, handleVisible, handleDangerVisible) => dispatch(addCashPayment(data, handleVisible, handleDangerVisible)),
    // submitCashPayment: (data) => dispatch(submitCashPayment(data)),
    // deleteCashPayment: (id) => dispatch(deleteCashPayment(id)),
    // resetFunction: () => dispatch(resetFunction()),
    getEmployeeDataWithStatus: (status) => dispatch(getEmployeeDataWithStatus(status)),

  };
};
const mapStateToProps = (state, ownProps) => ({
  ltAccount: state.HrReducer.ltAccount,
  isFetchingLTAccount: state.accountsLevelReducer.isFetchingLTAccount,
  employeeList: state.HrReducer.employeeList,
  isFetchingEmployeeData: state.HrReducer.isFetchingEmployeeData,
  addSTAccount: state.HrReducer.addSTAccount,

  
  activeEmployeeList: state.HrReducer.activeEmployeeList,
  isFetchingActiveEmployeeData: state.HrReducer.isFetchingActiveEmployeeData,

});

export default connect(mapStateToProps, mapDispatchToProps)(STReciving);
